<template>
    <component :is="component" v-if="component" :likeData="likeData"></component>
</template>

<script>
export default {
    name: "LikeLink",
    mixins: [],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {
        likeLayout: '',
        likeData: {}
    },
    data() {
        return {
            component: null,
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        this.loader()
                .then(() => {
                    this.component = () => this.loader()
                })
                .catch(() => {
                    this.component = () => import('@/template/like/LikeDefaultLayout')
                })
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {
        loader() {
            if (!this.likeLayout) {
                return null
            }
            return () => import(`@/template/like/${this.likeLayout}`)
        },
    },
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>